import type { ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export default function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: Props): JSX.Element {
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
      }}
    >
      <section
        style={{
          width: "100%",
          maxWidth: 420,
          background: "var(--card)",
          border: "1px solid var(--border)",
          borderRadius: 12,
          padding: "2rem",
        }}
      >
        <header style={{ marginBottom: "1.5rem" }}>
          <div
            style={{
              fontFamily: "monospace",
              fontSize: 14,
              color: "var(--muted)",
              marginBottom: 8,
            }}
          >
            cerberus
          </div>
          <h1 style={{ margin: 0, fontSize: "1.5rem" }}>{title}</h1>
          {subtitle ? (
            <p style={{ color: "var(--muted)", marginTop: 8 }}>{subtitle}</p>
          ) : null}
        </header>
        {children}
        {footer ? (
          <footer
            style={{
              marginTop: "1.5rem",
              fontSize: 14,
              color: "var(--muted)",
              textAlign: "center",
            }}
          >
            {footer}
          </footer>
        ) : null}
      </section>
    </main>
  );
}
